// 社群相關連結
import Image from 'next/image';
import { CRYPTO_CITY_OFFICIAL_URL, CDN_BASE } from '@/common/constant';

const NewsSocial = () => {
    return (
        <div
            className="between-center gap-x-[8px] mt-[20px] [&>a]:w-[calc((100%-16px)/3)] uxs:flex-wrap uxs:justify-center
          [&>a]:aspect-[220/256] [&>a]:rounded-[4px] [&>a]:overflow-hidden uxs:[&>a]:max-w-[350px] uxs:[&>a]:w-full uxs:gap-y-[10px] [&_img]:trans"
        >
            <a
                href={CRYPTO_CITY_OFFICIAL_URL.LINE}
                className="img-box group"
                target="_blank"
                rel="noreferrer noopener"
            >
                <Image
                    className="group-hover:opacity-[.7]"
                    width={220}
                    height={256}
                    src={CDN_BASE + 'layout/social_line.png'}
                    alt="crypto_city_line"
                    sizes="200px"
                    loading="lazy"
                />
            </a>
            <a
                href={CRYPTO_CITY_OFFICIAL_URL.THREADS}
                className="img-box group"
                target="_blank"
                rel="noreferrer noopener"
            >
                <Image
                    className="group-hover:opacity-[.7]"
                    width={220}
                    height={256}
                    src={CDN_BASE + 'layout/social_threads.png'}
                    alt="crypto_city_threads"
                    sizes="200px"
                    loading="lazy"
                />
            </a>
            <a
                href={CRYPTO_CITY_OFFICIAL_URL.TELEGRAM}
                className="img-box group"
                target="_blank"
                rel="noreferrer noopener"
            >
                <Image
                    className="group-hover:opacity-[.7]"
                    width={220}
                    height={256}
                    src={CDN_BASE + 'layout/social_telegram.png'}
                    alt="crypto_city_telegram"
                    sizes="200px"
                    loading="lazy"
                />
            </a>
        </div>
    );
};

export default NewsSocial;
